import React, {Fragment} from 'react';
import {Container, Grid, Paper} from '@mui/material';

import DataTable from './Grid';
import {styled} from '@mui/material/styles';

const StyledPaper = styled(Paper)(({theme})=>({
  padding: theme.spacing(2),
  display: 'flex',
  overflow: 'auto',
  flexDirection: 'column',
}));

export default function Dashboard() {
  return (
    <Fragment>
      <Container maxWidth='95%'>
        <Grid spacing={3} container>
          {/* Recent Users */}
          <Grid size={{xs: 12}}>
            <StyledPaper>
              <DataTable />
            </StyledPaper>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
}
